import { flexRender, Row } from "@tanstack/react-table";
import React, { useMemo, useState } from "react";
import { Icons } from "shared/ui";
import { TableData, ITableColumns } from "../table";
import style from "./table-rows.module.scss";
import cx from "classnames";

interface ITableRows {
  row: Row<TableData>;
  expandableColumn?: string;
  subRow?: boolean;
  header: ITableColumns[];
}

export const TableRows = ({ row, expandableColumn, subRow, header }: ITableRows) => {
  const [isOpen, setIsOpen] = useState(false);

  console.log(row);

  return (
    <>
      {
        <tr key={row.id} className={cx(style.row, row.original.className, row.original.isTotal && style.total)}>
          {row.getVisibleCells().map((cell, index) => {
            if (expandableColumn === cell.column.id && row.subRows.length > 0) {
              return (
                <td
                  key={cell.id}
                  onClick={() => setIsOpen(!isOpen)}
                  className={cx(
                    style.row_item,
                    index == 0 && subRow && style.sub_row,
                    header[index].align === "left" && style.left,
                    header[index].align === "center" && style.center,
                    header[index].align === "right" && style.right
                  )}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  <Icons.Down className={isOpen ? style.row_active : ""} />
                </td>
              );
            }

            return (
              <td
                key={cell.id}
                className={cx(
                  index == 0 && subRow && style.sub_row,
                  header[index].align === "left" && style.left,
                  header[index].align === "center" && style.center,
                  header[index].align === "right" && style.right
                )}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            );
          })}
        </tr>
      }
      {isOpen &&
        row.subRows.map((row) => (
          <TableRows header={header} expandableColumn={expandableColumn} row={row} key={row.id} subRow={true} />
        ))}
    </>
  );
};
